import { formatScheduleTime } from '../shared/datetime/timestamps';

const DAYS = {
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',
};

// How a schedule reads wherever it is shown: "Daily at 8:00 AM ADT", "Every Monday at
// 9:00 PM PDT", "On the 1st of each month at 8:00 AM ADT". The zone is the schedule's
// own and is always stated: it is the clock the schedule runs on, and it need not be
// the reader's or the organization's.
export function scheduleLabel({ frequency, time, dayOfWeek } = {}, zone) {
  const at = formatScheduleTime(time || '08:00', zone);
  const how = frequency || 'daily';
  if (how === 'daily') return `Daily at ${at}`;
  if (how === 'weekly') return `Every ${DAYS[dayOfWeek] ?? 'Monday'} at ${at}`;
  if (how === 'monthly') return `On the 1st of each month at ${at}`;
  // Said rather than guessed, hourly included: the scheduler knows only daily, weekly
  // and monthly and runs any other cadence once a day, so "Every hour" would describe
  // runs that never happen, and "Daily" would disagree with what is saved.
  return `On its ${how} schedule at ${at}`;
}

// The same for a stored automation: its schedule_type, the schedule_datetime JSON and
// its timezone.
export function storedScheduleLabel(automation) {
  if (automation?.schedule_type === 'on-demand') return 'On-demand';
  let schedule;
  try {
    schedule = JSON.parse(automation?.schedule_datetime || '{}') || {};
  } catch {
    return 'Scheduled';
  }
  return scheduleLabel(schedule, automation?.timezone);
}
